export enum StorageKey {
	AuthToken = 'grafemAuthToken',
	InstallDismissed = 'grafemInstallDismissed'
}
